import { Box, BoxProps, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useState } from 'react'
import { DropdownStateless } from '../../components/DropdownStateless'

interface DeviceListItemProps {
  item: any
  onUpdateStatusPress: any
  sizeConfig: any
  index: number
  keys: any
}

export const DeviceListItem = ({ item, index, onUpdateStatusPress, sizeConfig, keys }: DeviceListItemProps) => {
  const [selectedState, setSelectedState] = useState('')

  const getDropdownData = () => {
    return item?.deviceType === 'VOICEBOX'
      ? [
          {
            id: 0,
            value: 'ACTIVE',
          },
          {
            id: 1,
            value: 'INACTIVE',
          },
          {
            id: 2,
            value: 'DELINKED',
          },
        ].filter((ddItem) => ddItem.value !== item?.status)
      : [
          {
            id: 2,
            value: 'DELINKED',
          },
        ]
  }

  let lastId = 0
  return (
    <Box {...styles.container(item.status)} borderTopWidth={index === 0 ? 1 : 0}>
      {Object.keys(item).map((data, id) => {
        if (keys.includes(data)) {
          const size = sizeConfig?.[lastId]
          lastId++
          return (
            <>
              <ModBox
                f={size}
                testID={'table-cell-' + index + '-' + id}
                marginRight={18}
                paddingRight={0}
                show={data !== 'mapping'}>
                <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_21'} numberOfLines={1}>
                  {item[data]}
                </Text>
              </ModBox>
              <ModBox show={data === 'mapping'} f={size} marginRight={18} paddingRight={0}>
                <ModBox flexDirection={'row'} show={item?.deviceType === 'VOICEBOX' && item?.status !== 'DELINKED'}>
                  <DropdownStateless
                    value={selectedState}
                    data={getDropdownData()}
                    minWidth={120}
                    minHeight={32}
                    title={'Select'}
                    type={'default'}
                    selectedData={setSelectedState}
                  />
                  <SpacerNew size={24} direction="horizontal" />
                  <ButtonNew
                    title={'Update'}
                    height={32}
                    disabled={!selectedState}
                    onPress={() => {
                      onUpdateStatusPress(item, selectedState)
                      setSelectedState('')
                    }}
                  />
                </ModBox>
                <ModBox show={item?.deviceType !== 'VOICEBOX' || item?.status === 'DELINKED'}>
                  <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_21'} numberOfLines={1}>
                    {'NA'}
                  </Text>
                </ModBox>
              </ModBox>
            </>
          )
        }
        return null
      })}
    </Box>
  )
}

const styles = {
  container: (status: string) =>
    ({
      bg: 'BRAND_PRIMARY_WHITE',
      direction: 'row',
      display: 'flex',
      align: 'center',
      borderBottomWidth: 1,
      borderColor: 'GRAY_BORDER',
      height: 55,
      underlayColor: 'GRAY_BORDER',
      opacity: status?.toLowerCase?.() === 'completed' ? 0.6 : 1,
    } as BoxProps),
}
